export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/ibs`;
// export const API_BASE_URL = "http://localhost:3003";
// export const API_BASE_URL = `http://${window.location.hostname}:3003`;
// export const API_BASE_URL= "https://spark.indicrm.io/ibs";
// export const SOCKET_BASE_URL = "https://spark.indicrm.io";
export const SOCKET_BASE_URL = "http://localhost:3003";

export const VIEW_LEAD = "VIEW_LEAD";
export const VIEW_PROPERTY = "VIEW_PROPERTY";
export const EDIT_LEAD = "EDIT_LEAD";
export const DELETE_LEAD = "DELETE_LEAD";
export const VIEW_PRODUCT = "VIEW_PRODUCT";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const MODIFY_ALL = "MODIFY_ALL";
export const VIEW_ALL = "VIEW_ALL";
export const VIEW_ORDER = "VIEW_ORDER";
export const VIEW_USER = "VIEW_USER";
export const VIEW_CONTACT = "VIEW_CONTACT";
export const EDIT_CONTACT = "EDIT_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const VIEW_ACCOUNT = "VIEW_ACCOUNT";
export const EDIT_ACCOUNT = "EDIT_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const VIEW_BUSINESS = "VIEW_BUSINESS";
export const EDIT_BUSINESS = "EDIT_BUSINESS";
export const DELETE_BUSINESS = "DELETE_BUSINESS";
export const VIEW_INCIDENT = "VIEW_INCIDENT";

//FILE TYPES
export const PDF = "pdf";
export const DOC = "doc";
export const DOCX = "docx";
export const XLS = "xls";
export const XLSX = "xlsx";
export const CSV = "csv";
export const PNG = "png";
export const JPG = "jpg";
export const JPEG = "jpeg";

// export const LEAD_STATUS_VALUES = [{label : 'Open - Not Contacted', islast : false}, {label : 'Working Contacted', islast : false} , {label : 'Closed - Converted', islast : true}, {label : 'Closed - Not Converted', islast : true}];
export const LEAD_STATUS_VALUES = [
  {
    label: "Open - Not Contacted",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Working - Contacted",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Closed - Converted",
    sortorder: 3,
    is_converted: true,
    is_lost: false,
  },
  {
    label: "Closed - Not Converted",
    sortorder: 4,
    is_converted: false,
    is_lost: true,
  },
];
export const Product_CATEGORY_VALUES = [
  {
    label: "Software",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Hardware",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Fashion",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Retail",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Goods",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Furniture",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Stones",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Policy",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Others",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
];

export const Product_SUBCATEGORY_VALUES = [
  {
    label: "Subscription",
    sortorder: 1,
  },
  {
    label: "Insurance",
    sortorder: 2,
  },
  {
    label: "Implementation",
    sortorder: 2,
  },
  {
    label: "Goods",
    sortorder: 2,
  },
  {
    label: "Material",
    sortorder: 2,
  },
  {
    label: "Fashion",
    sortorder: 2,
  },
  {
    label: "Others",
    sortorder: 2,
  },
];

export const orderHeaders = [
  { key: "Id", label: "ORDER ID", sortable: false, show: false },
  { key: "Name", label: "ORDER NUMBER", sortable: true, show: true, hasId: true, id: "Id", type: "link", linkTo: "orders", inModel: true, },
  { key: "Party_Ledger__r.Name", label: "PARTY LEDGER", sortable: true, show: true, inModel: true, hasId: true, id: "Party_Ledger__r.Id", type: "link", linkTo: "ledgers", },
  { key: "Sales_Ledger__r.Name", label: "SALES LEDGER", sortable: true, show: false, inModel: true, hasId: true, id: "Sales_Ledger__r.Id", type: "link", linkTo: "ledgers", },
  { key: "Order_Date__c", label: "ORDER DATE", sortable: true, show: true, type: "date", inModel: true, },
  {
    key: "Type__c", label: "TYPE", sortable: true, show: true, inModel: true, type: "custom",
    renderer: (value) => {
      const map = {
        Purchase: { class: "bg-primary", icon: "fa fa-shopping-cart", text: "Purchase" },
        Sales: { class: "bg-success", icon: "fa fa-shopping-bag", text: "Sales" },
        Return: { class: "bg-danger", icon: "fa fa-undo", text: "Return" },
      };
      const item = map[value] || { class: "bg-secondary", icon: "fa fa-question", text: value || "Unknown" };
      return <span className={`badge ${item.class}`}><i className={item.icon}></i> {item.text}</span>;
    },
  },
  {
    key: "Order_Status__c", label: "ORDER STATUS", sortable: false, show: true, type: "custom", inModel: true,
    renderer: (value) => {
      const map = {
        Draft: { class: "bg-secondary", icon: "fa fa-file-o", text: "Draft" },
        Pending: { class: "bg-warning", icon: "fa fa-clock-o", text: "Pending" },
        Completed: { class: "bg-success", icon: "fa fa-check", text: "Completed" },
      };
      const item = map[value] || { class: "bg-secondary", icon: "fa fa-question", text: "Unknown" };
      return <span className={`badge ${item.class}`}><i className={item.icon}></i> {item.text}</span>;
    }
  },
  { key: "Total_Amount__c", label: "TOTAL AMOUNT", sortable: true, show: true, type: "currency", currency: "INR", inModel: true, },
  {
    key: "Tally_Sync__c",
    label: "TALLY SYNC",
    show: true,
    sortable: true,
    inModel: true,
    type: "custom",
    renderer: (value) => {
      const map = {
        Completed: { class: "bg-success", icon: "fa fa-check", text: "Completed" },
        "In Progress": { class: "bg-warning", icon: "fa fa-clock-o", text: "In Progress" },
        Start: { class: "bg-info", icon: "fa fa-refresh", text: "Start" },
        Error: { class: "bg-danger", icon: "fa fa-times", text: "Error" },
      };
      const item = map[value] || { class: "bg-secondary", icon: "fa fa-question", text: "Unknown" };
      return <span className={`badge ${item.class}`}><i className={item.icon}></i> {item.text}</span>;
    },
  },
  {
    key: "Order_Line_Items__r",
    label: "Order Line Items",
    values: [
      {
        key: "ItemOrLedger",
        label: "Item / Ledger",
        show: true,
        renderer: (row) =>
          row.Ledger__r
            ? row.Ledger__r.Name
            : row.Stock_Item__r?.Name || "-",
      },
      { key: "Quantity__c", label: "Quantity", show: true },
      { key: "Rate__c", label: "Rate", show: true },
      { key: "Amount__c", label: "Amount", show: true },
    ],
  }
];

export const voucherHeader = [
  { key: "Id", label: "VOUCHER ID", sortable: false, show: false },
  { key: "Name", label: "VOUCHER NUMBER", sortable: true, show: true, hasId: true, id: "Id", type: "link", linkTo: "vouchers", inModel: true, },
  { key: "Party_Ledger__r.Name", label: "PARTY LEDGER", sortable: true, show: true, inModel: true, },
  { key: "Amount__c", label: "AMOUNT", sortable: true, show: true, type: "currency", currency: "INR", inModel: true, },
  { key: "Date__c", label: "DATE", sortable: true, show: true, type: "date", inModel: true, },
  { key: "Type__c", label: "TYPE", sortable: true, show: true, type: "badge", inModel: true, },
  { key: "Order__r.Name", label: "ORDER", sortable: true, show: true, inModel: true, hasId: true, id: "Order__r.Id", type: "link", linkTo: "orders", },
  { key: "Reference_Number__c", label: "REFERENCE NUMBER", sortable: true, show: true, inModel: true, },
  {
    key: "Voucher_Entrys__r", label: "Voucher Line Items",
    values: [
      { key: "Stock_Item__r.Name", label: "Item Name", show: true },
      { key: "Rate__c", label: "Rate", show: true },
      { key: "Quantity__c", label: "Quantity", show: true },
      { key: "Amount__c", label: "Amount", show: true },
    ],
  },
];

export const ledgerHeader = [
  { key: "Id", label: "LEDGER ID", sortable: false, show: false },
  { key: "Name", label: "LEDGER NAME", sortable: true, show: true, hasId: true, id: "Id", type: "link", linkTo: "ledgers", inModel: true, },
  { key: "Closing_Balance__c", label: "CLOSING BALANCE", sortable: true, show: true, type: "currency", currency: "INR", inModel: true, },
  { key: "Opening_Balance__c", label: "OPENING BALANCE", sortable: false, show: false, type: "currency", currency: "INR", },
  { key: "Parent_Group__c", label: "PARENT GROUP", sortable: true, show: true, inModel: true, },
  { key: "State__c", label: "STATE", sortable: true, show: true, inModel: true },
  { key: "Legacy_AlterId__c", label: "LEGACY ALTER ID", sortable: true, show: true, inModel: true, },
  { key: "Legacy_GUID__c", label: "LEGACY GUID", sortable: false, show: false },
  { key: "OwnerId", label: "OWNER", sortable: false, show: false },
  { key: "CreatedById", label: "CREATED BY", sortable: false, show: false },
  { key: "LastModifiedById", label: "LAST MODIFIED BY", sortable: false, show: false },
  {
    key: "Ledger_GST_Details__r", label: "GST Details",
    values: [
      { key: "Name", label: "GST NUMBER", show: true },
      { key: "Applicable_From__c", label: "APPLICABLE FROM", show: true },
      { key: "Place_Of_Supply__c", label: "PLACE OF SUPPLY", show: true },
    ],
  },
];

export const stockItemHeader = [
  { key: "Id", label: "STOCK ITEM ID", sortable: false, show: false, },
  { key: "Name", label: "STOCK ITEM NAME", sortable: true, show: true, hasId: true, id: "Id", type: "link", linkTo: "stockitems", inModel: true },
  { key: "Rate__c", label: "RATE", sortable: true, show: true, type: "currency", currency: "INR", inModel: true },
  { key: "Closing_Amount__c", label: "CLOSING AMOUNT", sortable: false, show: false, type: "currency", currency: "INR", inModel: true },
  { key: "Units__c", label: "UNITS", sortable: true, show: true, inModel: true },
  { key: "Parent_Group__c", label: "PARENT", sortable: true, show: true, inModel: true },
  { key: "Closing_Quantity__c", label: "CLOSING QUANTITY", sortable: false, show: false, },
  { key: "GST_Applicable_From__c", label: "GST APPLICABLE FROM", sortable: false, show: false, type: "date", },
  {
    key: "GST_Applicable__c", label: "GST APPLICABLE", sortable: true, show: true, type: "custom", inModel: true,
    renderer: (value) =>
      value ? (
        <span className="badge bg-success">Yes</span>
      ) : (
        <span className="badge bg-secondary">No</span>
      ),
  },
  {
    key: "Is_Taxable__c", label: "IS TAXABLE", sortable: true, show: true, type: "custom", inModel: true,
    renderer: (value) =>
      value ? (
        <span className="badge bg-info">Taxable</span>
      ) : (
        <span className="badge bg-warning">Non-Taxable</span>
      ),
  },
  { key: "Legacy_AlterId__c", label: "LEGACY ALTER ID", sortable: false, show: false, },
  { key: "Legacy_GUID__c", label: "LEGACY GUID", sortable: false, show: false, },
  { key: "OwnerId", label: "OWNER", sortable: false, show: false, },
  { key: "CreatedById", label: "CREATED BY", sortable: false, show: false, },
  { key: "LastModifiedById", label: "LAST MODIFIED BY", sortable: false, show: false, },
  { key: "LastModifiedDate", label: "MODIFIED DATE", sortable: false, show: false, type: "date", inModel: true, },
  { key: "CreatedDate", label: "CREATED DATE", sortable: false, show: false, type: "date", inModel: true, },
  {
    key: "GST_Rate_Details__r", label: "GST Rate Details",
    values: [
      { key: "Name", label: "Name", show: true },
      {
        key: "Rate__c", label: "Rate", show: true, type: "custom",
        renderer: (value) => {
          console.log("Rendering Rate__c →", value);
          const safeValue = value ?? 0; // default to 0 if null/undefined
          return safeValue
            ? <span className="badge bg-success">{safeValue}%</span>
            : <span className="badge bg-secondary">0%</span>;
        },
      },
      { key: "State__c", label: "PState", show: true },
      { key: "Valuation_Type__c", label: "Valuation Type", show: true },
    ],
  },
];

export const taskHeaders = [
  { key: "Id", label: "Task ID", sortable: false, show: false, },
  { key: "Name", label: "Task Number", sortable: false, show: true, inModel: true, hasId: true, id: "Id", type: "link", linkTo: "tasks", },
  { key: "Title__c", label: "Task Title", sortable: true, show: true, inModel: true, },
  {
    key: "Status__c", label: "Status", sortable: false, show: true, type: "custom", inModel: true,
    renderer: (value) => {
      const map = {
        New: { class: "bg-secondary", text: "New" },
        'In Progress': { class: "bg-warning", text: "In Progress" },
        Approval: { class: "bg-primary", text: "Approval" },
        Completed: { class: "bg-success", text: "Completed" },
      };
      const item = map[value] || { class: "bg-secondary", text: "Unknown" };
      return <span className={`badge ${item.class}`}>{item.text}</span>;
    }
  },
  { key: "Priority__c", label: "Priority", sortable: true, show: true, inModel: true, },
  { key: "Start_Date__c", label: "Start Date", sortable: true, show: true, type: "date", inModel: true, },
  { key: "End_Date__c", label: "End Date", sortable: true, show: true, type: "date", inModel: true, },
  { key: "OwnerId__r.Name", label: "Owner", sortable: true, show: true, inModel: true, },
  { key: "Description__c", label: "Description", show: false, type: "textarea", inModel: true, },
  {
    key: "Task_Assignees__r",
    label: "Assign To Users",
    values: [
      {
        key: "records",
        label: "Name",
        show: true,
        renderer: (row) =>
          row.ContactId__r.Name
            ? row.ContactId__r.Name
            : "-",
      },
      {
        key: "records",
        label: "Email",
        show: true,
        renderer: (row) =>
          row.ContactId__r?.Email
            ? row.ContactId__r.Email
            : "-",
      },
      {
        key: "records",
        label: "Phone",
        show: true,
        renderer: (row) =>
          row.ContactId__r?.Phone
            ? row.ContactId__r.Phone
            : "-",
      },
    ]
  },
  { key: "Due_TIme__c", label: "Due Time", sortable: true, show: true, inModel: true, }
];